import Content from '../../content.js';

namespace('IO.Views.TwoFactorAuths', function (exports) {
  'use strict';

  var Index = Content.extend({
    render: function () {
      Duo.init(window.duo_options);
      Duo.ready();
    },
  });

  exports.Index = Index;
});
